import React from 'react';
import { FiPlus } from 'react-icons/fi';

import { BaseButton } from '../../../../components/BaseButton/BaseButton';

interface LinkBuyerButtonProps {
  onPress: () => void;
  disabled?: boolean;
}

export const LinkBuyerButton: React.FC<LinkBuyerButtonProps> = ({
  onPress,
  disabled = false,
}) => {
  return (
    <BaseButton
      color="primary"
      variant="flat"
      startContent={<FiPlus className="h-4 w-4" />}
      onPress={onPress}
      isDisabled={disabled}
      size="sm"
    >
      Link Buyer
    </BaseButton>
  );
};
